<template>
  <b-card title="ผลการค้นหา">
    <!-- search input -->
    <div class="custom-search d-flex justify-content-end">
      <b-form-group>
        <div class="d-flex align-items-center">
          <label class="mr-1">Search</label>
          <b-form-input
            v-model="searchTerm"
            placeholder="Search"
            type="text"
            class="d-inline-block"
          />
        </div>
      </b-form-group>
    </div>

    <!-- table -->
    <vue-good-table
      ref="my-table-user"
      @on-selected-rows-change="selectionChanged"
      :columns="columns"
      :rows="rows"
      :rtl="direction"
      :line-numbers="true"
      :search-options="{
        enabled: true,
        externalQuery: searchTerm,
      }"
      :select-options="{
        enabled: true,
        selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
        selectionInfoClass: 'custom-class',
        selectionText: 'rows selected',
        clearSelectionText: 'clear',
        disableSelectInfo: true, // disable the select info panel on top
        selectAllByGroup: false, // when used in combination with a grouped table, add a checkbox in the header row to check/uncheck the entire group
      }"
      :pagination-options="{
        enabled: true,
        perPage: pageLength,
      }"
    >
      <template slot="table-row" slot-scope="props">
        <!-- Column: Name -->
        <span v-if="props.column.field === 'department'" class="text-nowrap">
          {{ props.row.departmentName }}
        </span>

        <!-- Column: Complain_Subject -->
        <span v-if="props.column.field === 'role'" class="text-nowrap">
          {{ props.row.roleName }}
        </span>

        <span v-if="props.column.field === 'exclusive'" class="text-nowrap">
          <span
            v-if="
              props.row.roleId.toLowerCase() === setting.complaintRoleId.area
            "
          >
            <span>{{ props.row.areaName }}</span>
          </span>
          <span
            v-else-if="
              props.row.roleId.toLowerCase() ===
                setting.complaintRoleId.province
            "
          >
            <span>{{ props.row.areaName }} / {{ props.row.provinceName }}</span>
          </span>
          <span
            v-else-if="
              props.row.roleId.toLowerCase() === setting.complaintRoleId.bangkok
            "
          >
            <span
              >{{ props.row.provinceName }} / {{ props.row.districtName }}</span
            >
          </span>
          <span
            v-else-if="
              props.row.roleId.toLowerCase() ===
                setting.complaintRoleId.secretary
            "
          >
            <!-- <span>{{ props.row.secretaryNameStr }}</span> -->
            <span v-for="item in props.row.secretaryNameList">{{ item }}</span>
          </span>
          <span v-else> </span>
        </span>

        <!-- Column: Action -->
        <span v-else-if="props.column.field === 'action'">
          <span
            v-if="
              props.row.roleId.toLowerCase() === setting.complaintRoleId.area ||
                props.row.roleId.toLowerCase() ===
                  setting.complaintRoleId.province ||
                props.row.roleId.toLowerCase() ===
                  setting.complaintRoleId.bangkok ||
                props.row.roleId.toLowerCase() ===
                  setting.complaintRoleId.secretary
            "
          >
            <span>
              <b-dropdown
                variant="link"
                toggle-class="text-decoration-none"
                no-caret
              >
                <template v-slot:button-content>
                  <b-button
                    v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                    variant="outline-primary"
                    class="text-body align-middle mr-25"
                  >
                    <feather-icon icon="SettingsIcon" class="mr-50" />
                    <span class="align-middle">จัดการ</span>
                  </b-button>
                </template>

                <b-dropdown-item
                  v-if="
                    props.row.roleId.toLowerCase() ===
                      setting.complaintRoleId.area ||
                      props.row.roleId.toLowerCase() ===
                        setting.complaintRoleId.province ||
                      props.row.roleId.toLowerCase() ===
                        setting.complaintRoleId.bangkok
                  "
                >
                  <b-dropdown-item
                    @click="onProvinceManageBtnClicked(props.row)"
                  >
                    <feather-icon icon="Edit2Icon" class="mr-50" />
                    <span>แก้ไขสิทธิ์จังหวัด</span>
                  </b-dropdown-item>
                </b-dropdown-item>

                <b-dropdown-item
                  v-if="
                    props.row.roleId.toLowerCase() ===
                      setting.complaintRoleId.secretary
                  "
                >
                  <b-dropdown-item
                    @click="onSecretaryManageBtnClicked(props.row, 1)"
                  >
                    <feather-icon icon="Edit2Icon" class="mr-50" />
                    <span>เพิ่มสิทธิ์การเป็นเลขา</span>
                  </b-dropdown-item>
                  <b-dropdown-item
                    @click="onSecretaryManageBtnClicked(props.row, 2)"
                  >
                    <feather-icon icon="Edit2Icon" class="mr-50" />
                    <span>ถอนสิทธิ์การเป็นเลขา</span>
                  </b-dropdown-item>
                </b-dropdown-item>

                <!-- <b-dropdown-item @click="onProvinceManageBtnClicked(props.row)">
                  <feather-icon icon="Edit2Icon" class="mr-50" />
                  <span>แก้ไข</span>
                </b-dropdown-item> -->
              </b-dropdown>
            </span>
          </span>
        </span>
        <!-- Column: Info -->
        <span v-if="props.column.field === 'info'" class="text-nowrap">
          <b-button
            v-b-tooltip
            v-bind:title="
              'ดำเนินการโดย : ' +
                props.row.createBy +
                '  ดำเนินการวันที่ : ' +
                props.row.createDateSt
            "
            variant="outline-info"
            >!</b-button
          >
        </span>
        <!-- Column: Common -->
        <!-- <span v-else>
          {{ props.formattedRow[props.column.field] }}
        </span> -->
      </template>

      <!-- pagination -->
      <template slot="pagination-bottom" slot-scope="props">
        <div class="d-flex justify-content-between flex-wrap">
          <div class="d-flex align-items-center mb-0 mt-1">
            <span class="text-nowrap ">
              แสดง 1 ถึง
            </span>
            <b-form-select
              v-model="pageLength"
              :options="['10', '25', '50', '100']"
              class="mx-1"
              @input="
                (value) => props.perPageChanged({ currentPerPage: value })
              "
            />
            <span class="text-nowrap"> จาก {{ props.total }} รายการ </span>
          </div>
          <div>
            <b-pagination
              :value="1"
              :total-rows="props.total"
              :per-page="pageLength"
              first-number
              last-number
              align="right"
              prev-class="prev-item"
              next-class="next-item"
              class="mt-1 mb-0"
              @input="(value) => props.pageChanged({ currentPage: value })"
            >
              <template #prev-text>
                <feather-icon icon="ChevronLeftIcon" size="18" />
              </template>
              <template #next-text>
                <feather-icon icon="ChevronRightIcon" size="18" />
              </template>
            </b-pagination>
          </div>
        </div>
      </template>
    </vue-good-table>

    <div class="custom-search d-flex justify-content-end mt-2">
      <b-button variant="danger" @click="onDeleteBtnClicked">
        ลบสิทธิ์การใช้งาน
      </b-button>
    </div>

    <ModalProvinceManage
      @handle-submit="onProvinceManageSubmit"
      ref="modal-province-manage"
    />

    <ModalAddSecretary
      @handle-submit-add="onSecretaryAddSubmit"
      ref="modal-add-secretary"
    />

    <ModalCancelSecretary
      @handle-submit-cancel="onSecretaryCancelSubmit"
      ref="modal-cancel-secretary"
    />
  </b-card>
</template>

<script>
import {
  BButton,
  BAvatar,
  BBadge,
  BPagination,
  BFormGroup,
  BFormInput,
  BFormSelect,
  BDropdown,
  BDropdownItem,
  BCard,
  BCardHeader,
  BCardBody,
  BOverlay,
  VBTooltip,
} from "bootstrap-vue";
import { VueGoodTable } from "vue-good-table";

import ModalProvinceManage from "./ModalProvinceManage";
import ModalAddSecretary from "./ModalAddSecretary";
import ModalCancelSecretary from "./ModalCancelSecretary";

import Ripple from "vue-ripple-directive";
import store from "@/store/index";
import { codeBasic } from "@/views/table/vue-good-table/code";
import TableHeaders from "./commonTableUserProfileHeader.js";
import * as roleStore from "@/store/api/role/index.js";
import * as departmentRoleStore from "@/store/api/role/departmentRole.js";
import * as userData from "@/auth/localStorageUtils.js";

import appsettings from "@/store/app-settings";

export default {
  directives: {
    Ripple,
    "b-tooltip": VBTooltip,
  },
  components: {
    VueGoodTable,
    BButton,
    BAvatar,
    BBadge,
    BPagination,
    BFormGroup,
    BFormInput,
    BFormSelect,
    BDropdown,
    BDropdownItem,
    BCard,
    BCardHeader,
    BCardBody,
    BOverlay,
    TableHeaders,
    ModalProvinceManage,
    ModalAddSecretary,
    ModalCancelSecretary,
    VBTooltip,
  },
  props: {
    mode: {
      type: String,
      required: true,
    },
  },
  setup(props) {
    return {
      tabMode: props.mode,
    };
  },
  data() {
    return {
      pageLength: 10,
      dir: false,
      codeBasic,
      columns: TableHeaders,
      areas: [],
      rows: [],
      searchTerm: "",
      status: [
        {
          1: "Current",
          2: "Professional",
          3: "Rejected",
          4: "Resigned",
          5: "Applied",
        },
        {
          1: "light-primary",
          2: "light-success",
          3: "light-danger",
          4: "light-warning",
          5: "light-info",
        },
      ],
      params: {},
      setting: appsettings,
      secretaryName: "",
    };
  },
  computed: {
    statusVariant() {
      const statusColor = {
        /* eslint-disable key-spacing */
        Current: "light-primary",
        Professional: "light-success",
        Rejected: "light-danger",
        Resigned: "light-warning",
        Applied: "light-info",
        /* eslint-enable key-spacing */
      };

      return (status) => statusColor[status];
    },
    direction() {
      if (store.state.appConfig.isRTL) {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.dir = true;
        return this.dir;
      }
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      this.dir = false;
      return this.dir;
    },
  },
  created() {},
  methods: {
    onSearchSubmit(params) {
      console.log("onSearchSubmit", params);
      this.$emit("handleOverlay", true);
      this.params = params;

      const _this = this;
      departmentRoleStore
        .getUserRole(params)
        .then(function(response) {
          // handle success
          console.log("then", response);
          _this.rows = response.data.data;
          console.log("result", _this.rows);
        })
        .catch(function(error) {
          // handle error
          console.log("error", error);
        })
        .then(function() {
          // always executed
          console.log("GET");
          _this.$emit("handleOverlay", false);
        });
    },
    onDeleteBtnClicked() {
      const _this = this;

      const selectedRoles = _this.$refs["my-table-user"].selectedRows;
      console.log("selectedRoles", selectedRoles);

      if (selectedRoles.length === 0) {
        _this.$bvToast.toast("กรุณาเลือกสิทธิ์ที่ต้องการลบ", {
          title: `กรุณาเลือกสิทธิ์ที่ต้องการลบอย่างน้อย 1 สิทธิ์`,
          variant: "danger",
          solid: false,
        });
        return;
      }

      this.$swal({
        title: "คุณต้องการลบข้อมูลใช่หรือไม่?",
        text: "เมื่อลบแล้วไม่สามารถกู้คืนได้อีก!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "ลบข้อมูล",
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          const roleIds = selectedRoles.map((value) => {
            return value.userDepartmentRoleId;
          });

          const params = {
            userDepartmentRoleIds: roleIds,
          };

          departmentRoleStore
            .deleteItem(params)
            .then((response) => {
              if (response.data.success === true) {
                this.$bvToast.toast("บันทึกข้อมูลสำเร็จ", {
                  title: `ระบบได้บันทึกการแก้ไขของท่านแล้ว`,
                  variant: "success",
                  solid: false,
                });

                _this.onSearchSubmit(_this.params);
              } else {
                _this.$bvToast.toast("เกิดข้อผิดพลาด", {
                  title: `เกิดข้อผิดพลาดในการบันทึกข้อมูล`,
                  variant: "danger",
                  solid: false,
                });
              }
            })
            .catch((error) => {
              console.log("error", error);
              _this.$bvToast.toast("เกิดข้อผิดพลาด", {
                title: `เกิดข้อผิดพลาดในการบันทึกข้อมูล`,
                variant: "danger",
                solid: false,
              });
            });
        }
      });
    },
    onComplainSend(id) {
      this.$emit("handleSend", id);
    },
    onComplainGroupManage(id) {
      this.$emit("handleGroup", id);
    },
    confirmText() {
      this.$swal({
        title: "คุณต้องการลบข้อมูลใช่หรือไม่?",
        text: "เมื่อลบแล้วไม่สามารถกู้คืนได้อีก!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "ลบข้อมูล",
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          this.$swal({
            icon: "success",
            title: "ลบข้อมูล สำเร็จ",
            customClass: {
              confirmButton: "btn btn-success",
            },
          });
        }
      });
    },
    selectionChanged() {
      // console.log("ref", this.$refs);
      this.$forceUpdate();
      this.$emit("handle-select", this.$refs["my-table"].selectedRows);
    },
    onProvinceManageBtnClicked(user) {
      console.log("data", user);
      const _this = this;
      this.$refs["modal-province-manage"].$refs["modal-province-manage"].show();
      if (user.roleId.toLowerCase() === _this.setting.complaintRoleId.area) {
        this.$refs["modal-province-manage"].onShow(user, 1);
      } else if (
        user.roleId.toLowerCase() === _this.setting.complaintRoleId.province
      ) {
        this.$refs["modal-province-manage"].onShow(user, 2);
      } else if (
        user.roleId.toLowerCase() === _this.setting.complaintRoleId.bangkok
      ) {
        this.$refs["modal-province-manage"].onShow(user, 3);
      }
    },
    onSecretaryManageBtnClicked(user, mode) {
      console.log("dataLogin", user);
      console.log("Mode", mode);

      // this.$refs["modal-secretary-add-manage"].$refs["modal-secretary-add-manage"].show();
      if (mode == 1) {
        this.$refs["modal-add-secretary"].$refs["modal-add-secretary"].show();
        this.$refs["modal-add-secretary"].onShow(user, mode); // เพิ่มสิทธิ์การเป็นเลขา
      } else if (mode == 2) {
        this.$refs["modal-cancel-secretary"].$refs[
          "modal-cancel-secretary"
        ].show();
        // this.$refs["commonTableSecretaryModal"].$refs["commonTableSecretaryModal"].onShowCancel(user);
        this.$refs["modal-cancel-secretary"].onShow(user, mode); // ถอนสิทธิ์การเป็นเลขา
      }
    },
    onProvinceManageSubmit(user) {
      const _this = this;

      departmentRoleStore
        .postUpdate(
          user.userDepartmentRoleId,
          user.area,
          user.province,
          user.district,
          user.subDistrict
        )
        .then((response) => {
          if (response.data.success === true) {
            this.$bvToast.toast("บันทึกข้อมูลสำเร็จ", {
              title: `ระบบได้บันทึกการแก้ไขของท่านแล้ว`,
              variant: "success",
              solid: false,
            });

            _this.$refs["modal-province-manage"].$refs[
              "modal-province-manage"
            ].hide();

            console.log("Before", _this.params);

            _this.onSearchSubmit(_this.params);
          } else {
            _this.$bvToast.toast("เกิดข้อผิดพลาด", {
              title: `เกิดข้อผิดพลาดในการบันทึกข้อมูล`,
              variant: "danger",
              solid: false,
            });
          }
        })
        .catch((error) => {
          console.log("error", error);
          _this.$bvToast.toast("เกิดข้อผิดพลาด", {
            title: `เกิดข้อผิดพลาดในการบันทึกข้อมูล`,
            variant: "danger",
            solid: false,
          });
        });
    },
    onSecretaryAddSubmit(user) {
      const _this = this;

      departmentRoleStore
        .postSecretaryUpdate(user)
        .then((response) => {
          if (response.data.success === true) {
            this.$bvToast.toast("บันทึกข้อมูลสำเร็จ", {
              title: `ระบบได้บันทึกการแก้ไขของท่านแล้ว`,
              variant: "success",
              solid: false,
            });

            _this.$refs["modal-add-secretary"].$refs[
              "modal-add-secretary"
            ].hide();

            console.log("Before", _this.params);

            _this.onSearchSubmit(_this.params);
          } else {
            _this.$bvToast.toast("เกิดข้อผิดพลาด", {
              title: `เกิดข้อผิดพลาดในการบันทึกข้อมูล`,
              variant: "danger",
              solid: false,
            });
          }
        })
        .catch((error) => {
          console.log("error", error);
          _this.$bvToast.toast("เกิดข้อผิดพลาด", {
            title: `เกิดข้อผิดพลาดในการบันทึกข้อมูล`,
            variant: "danger",
            solid: false,
          });
        });
    },
    onSecretaryCancelSubmit(user) {
      console.log("ทดสอบ CancelSubmit");
    },
  },
};
</script>
